<template>
  <header class="main-header">
    <!-- Logo -->
    <a href="/Admin/Dashboard" class="logo">
      <!-- mini logo for sidebar mini 50x50 pixels -->
      <span class="logo-mini">
        <b>NB</b>TC
      </span>
      <!-- logo for regular state and mobile devices -->
      <span class="logo-lg">
        <b>ProCheck</b>&nbsp;CMS
      </span>
    </a>

    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top">
      <!-- Sidebar toggle button-->
      <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>
      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <!-- User Account: style can be found in dropdown.less -->
          <li class="dropdown user user-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <img :src="profileImg" class="user-image" alt="User Image" />
              <span class="hidden-xs">{{fullname }}</span>
            </a>
            <ul class="dropdown-menu">
              <!-- User image -->
              <li class="user-header">
                <img
                  :src="profileImg"
                  class="img-circle"
                  alt="User Image"
                />

                <p>
                  {{ fullname }} 
                  <!-- <small>{{ currentUser.createdAt }}</small> -->
                </p>
              </li>
              <!-- Menu Body -->

              <!-- Menu Footer-->
              <li class="user-footer">
                <div class="pull-left">
                  <!-- <a class="btn btn-default btn-flat" @click="toProfile()">ข้อมูลส่วนตัว</a> -->
                  <router-link class="btn btn-default btn-flat" to="/Admin/Profile">ข้อมูลส่วนตัว</router-link>
                </div>
                <div class="pull-right">
                  <button @click="logout" class="btn btn-default btn-flat">ออกจากระบบ</button>
                </div>
              </li>
            </ul>
          </li>
          <!-- Control Sidebar Toggle Button -->
        </ul>
      </div>
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <!-- User Account: style can be found in dropdown.less -->
          <li class="dropdown user user-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <span class="hidden-xs"><i class="el-icon-info"></i></span>
            </a>
            <ul class="dropdown-menu" style="width: 260px;">
              <li>
                 <router-link to="/Admin/Terms_and_condition"> เงื่อนไขการให้บริการ</router-link>
              </li>
              <li>
                  <router-link to="/Admin/User_privacy">ข้อกำหนดและนโยบายข้อมูลส่วนบุคคล</router-link>
              </li>
              <li>
                  <router-link to="/Admin/Security_policy">นโยบายด้านความปลอดภัย</router-link>
              </li>
              <li>
                <router-link to="/Admin/Cookie_policy">นโยบายคุกกี้</router-link>
              </li>
            </ul>
          </li>
          <!-- Control Sidebar Toggle Button -->
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "va-navibar",
  computed: {
    ...mapState({
      fullname:store => store.Menu.fullname,
      profileImg:store => store.Menu.profileImg,
      unreadMessagesCount: store => store.Menu.messages.length,
      unreadMessagesCount: store => store.Menu.messages.length,
      unreadNotificationsCount: store => store.Menu.notifications.length,
      remainTasksCount: store => store.Menu.remark.length,
      currentUser: store => store.Menu.main
    })
  },
   mounted(){
     this.setCookie()
   },
  methods: {
    ...mapActions({
      logout_store: "Login_store/logout",
      setCookie : "Menu/setCookie"
    }),
    toProfile() {
      this.$router.push({ name: "Profile" });
    },
    logout() {
      this.logout_store();
    }
  }
};
</script>
